export default __webpack_public_path__ + "static/footer-logo-new-2-30f81ffbcf41228f813c5a24dff9e564.svg";